var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MerchantPaymentList',{attrs:{"title":"Success Transactions","default-status":"paid","status-options":_vm.statusOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }